import { render } from "./formEditApoio.vue?vue&type=template&id=698c843c"
import script from "./formEditApoio.vue?vue&type=script&lang=js"
export * from "./formEditApoio.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__